export function isStationEntry(path: string): boolean {
  return (
    path === '/station-reference' ||
    path.startsWith('/station-reference/') ||
    path === '/station-acceptance' ||
    path.startsWith('/dev/gate-acceptance/') ||
    path.startsWith('/station-terminal/')
  );
}
